import styles from "./ListMessage.module.scss";

interface FilterListMessageProps {
  message: string;
  dataTestId?: string;
}

export const FilterListMessage = ({
  message,
  dataTestId,
}: FilterListMessageProps) => {
  return (
    <div
      {...(dataTestId ? { "data-testid": dataTestId } : {})}
      className={styles.message}
    >
      {message}
    </div>
  );
};
